import { render, staticRenderFns } from "./bmList.vue?vue&type=template&id=a28a5850&scoped=true"
import script from "./bmList.vue?vue&type=script&lang=js"
export * from "./bmList.vue?vue&type=script&lang=js"
import style0 from "./bmList.vue?vue&type=style&index=0&id=a28a5850&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28a5850",
  null
  
)

export default component.exports